import React, {Component} from 'react'

export default class Help extends Component {
    constructor(props) {
        super(props)

        this.translation = JSON.parse(localStorage.translation)[localStorage.language];
    }

    render() {
        return (
            <div className="help">
                <div className="header_block">
                    <h2>{this.translation['FAQ']}</h2>
                    <hr/>
                </div>
                <div className="help_block">
                    <p className="question">— {this.translation['How can I send CPTs']}</p>
                    <p className="question">— {this.translation['Where can I purchase CPT tokens?']}</p>
                    <p className="question">— {this.translation['How to change the two-factor']}</p>
                    <p className="question">— {this.translation['Why are CPT tokens displayed']}</p>
                    <p className="question">— {this.translation['What is this statement']}</p>
                    <p className="question">— {this.translation['What does the phrase']}</p>
                    <p className="question">— {this.translation['What does the phrase wallet']}</p>
                    <p className="question">— {this.translation['What is the future price of CPT?']}</p>
                    <p className="question">— {this.translation['Where do I find information']}</p>
                    <div className="help_footer">
                        <p>{this.translation['To contact Cryptaur Support']}:</p>
                        <p className="footnote">{this.translation['write to our']} 24/7 <a href="/">{this.translation['chat']}</a> {this.translation['or e-mail']} <a href="mailto:support@cryptaur.com">support@cryptaur.com</a></p>
                    </div>
                </div>
            </div>
        )
    }
}
